<template>
  <div>
    <div class="search-content">
      <div class="search-input-wrapper">
        <b-form-input
          class="search-input"
          v-model="input"
          size="sm"
          @keydown="onKeyDown"
          :placeholder="$t('SearchInput.placeholder')"
          >
        </b-form-input>
        <b-button
          class="clear-button"
          size="sm"
          variant="danger"
          @click="onClickClear"
          v-if="input.length > 0"
          >
          <i class="fas fa-times"></i>
        </b-button>
        <b-button
          class="search-button"
          size="sm"
          variant="primary"
          @click="onClickSearch"
          >
          <i class="fas fa-search"></i>
        </b-button>
      </div>
    </div>
    <div class="result-list">
      <b-list-group-item
        v-if="loading"
        class="list-group-item-expand"
        >
        <div class="text-center">
          <b-spinner variant="primary" small />
        </div>
      </b-list-group-item>
      <b-list-group 
        class="result-list-group"
        v-if="searched.length > 0"
        >
        <b-list-group-item
          v-for="(item, index) in computedSearched"
          :key="'row-' + index"
          button
          @click="onSelect(item)"
          >
          <div>{{ displayAddress(item, locale) }}</div>
          <small>{{ displayAddress(item, oppLocale) }}</small>
        </b-list-group-item>
      </b-list-group>
      <b-list-group-item
        v-if="searched.length > 0"
        button
        @click="hide = !hide"
        class="list-group-item-expand"
        >
        <div class="text-center">
          <i class="fa" :class="hide ? 'fa-caret-down' : 'fa-caret-up'"/>
        </div>
      </b-list-group-item>
    </div>
  </div>
</template>

<script>
import langEn from "./lang/en.json";
import langZh from "./lang/zh.json";

import common from '@/mixins/common.js'

import { Main } from '@/event-bus/main.js'

export default {
  name: "SearchInput",
  mixins: [common],
  components: {
    
  },
  props: {
    
  },
  data: function() {
    return {
      input: "",
      searched: [],
      hide: false,
      loading: false,
    }
  },
  computed: {
    computedSearched() {
      if(this.hide) {
        return [];
      } else {
        return this.searched;
      }
    },
  },
  methods: {
    onClickSearch() {
      this.onSearch({
        value: this.input,
        fields: ['search.' + this.locale]
      });
    },
    onSearch(payload) {
      if(payload.value == null || payload.value.length == 0) {
        this.searched = [];
      } else {
        this.loading = true;
        this.$store.dispatch('addressQuery/search', {
          params: {
            q: payload.value,
            t: 20
          }
        })
        .then(val => {
          this.searched = val.SuggestedAddress;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
      }
    },
    onKeyDown(event) {
      if(event.key === 'Enter') {
        this.onClickSearch();
      }
    },
    onSelect(payload) {
      let _payload = Object.assign({}, {
        zh: this.displayAddress(payload, 'zh'),
        en: this.displayAddress(payload, 'en'),
        lat: this.getProperty(payload, [['Address', 'PremisesAddress', 'GeospatialInformation', 'Latitude']], -1),
        lng: this.getProperty(payload, [['Address', 'PremisesAddress', 'GeospatialInformation', 'Longitude']], -1)
      });
      Main.$emit('select', _payload);
    },
    onClickClear() {
      this.input = '';
      this.searched = [];
    },
    displayAddress(item, lang) {
      if (lang == 'zh') {
        return this.fullAddressZh(item.Address.PremisesAddress.ChiPremisesAddress);
      } else {
        return this.fullAddressEn(item.Address.PremisesAddress.EngPremisesAddress);
      }
    },
    fullAddressEn(item) {
      var region = this.getProperty(item, [['Region']], '');

      var district = this.getProperty(item, [['EngDistrict', 'DcDistrict']], '');

      var streetLocation = this.getProperty(item, [['EngStreet', 'LocationName']], '');
      var streetName = this.getProperty(item, [['EngStreet', 'StreetName']], '')
      var streetNo = this.getProperty(item, [['EngStreet', 'BuildingNoFrom']], '')

      var villageLocation = this.getProperty(item, [['EngVillage', 'LocationName']], '');
      var villageName = this.getProperty(item, [['EngVillage', 'VillageName']], '')
      var villageNo = this.getProperty(item, [['EngVillage', 'BuildingNoFrom']], '')

      var estate = this.getProperty(item, [['EngEstate', 'EstateName']], '')

      var building = this.getProperty(item, [['BuildingName']], '');

      var blockDes = this.getProperty(item, [['EngBlock', 'BlockDescriptor']], '')
      var blockNo = this.getProperty(item, [['EngBlock', 'BlockNo']], '')

      return blockDes + ' ' + blockNo + (blockNo ? ', ' : '') + // Block
        building + (building ? ', ' : '') + // Building
        estate + (estate ? ', ' : '') + // Estate
        streetName + (streetName && streetNo ? ' No. ' : '') + streetNo + ' ' + // Street Name
        villageName + (villageName && villageNo ? ' No. ' : '') + villageNo + ' ' + // Village Name
        streetLocation + (streetLocation ? ', ' : '') + // Street Location
        villageLocation + (villageLocation ? ', ' : '') + // Village Location
        district + (district ? ', ' : '') +
        region;
    },
    fullAddressZh(item) {
      var region = this.getProperty(item, [['Region']], '');

      var district = this.getProperty(item, [['ChiDistrict', 'DcDistrict']], '');

      var streetLocation = this.getProperty(item, [['ChiStreet', 'LocationName']], '');
      var streetName = this.getProperty(item, [['ChiStreet', 'StreetName']], '');
      var streetNo = this.getProperty(item, [['ChiStreet', 'BuildingNoFrom']], '');

      var villageLocation = this.getProperty(item, [['ChiVillage', 'LocationName']], '');
      var villageName = this.getProperty(item, [['ChiVillage', 'VillageName']], '');
      var villageNo = this.getProperty(item, [['ChiVillage', 'BuildingNoFrom']], '');

      var estate = this.getProperty(item, [['ChiEstate', 'EstateName']], '');

      var building = this.getProperty(item, [['BuildingName']], '');

      var blockDes = this.getProperty(item, [['ChiBlock', 'BlockDescriptor']], '');
      var blockNo = this.getProperty(item, [['ChiBlock', 'BlockNo']], '');

      return region + ' ' + // Region
        district + ' ' + // District
        streetLocation + ' ' + // Street Location
        villageLocation + ' ' + // Village Location
        streetName + streetNo + (streetName && streetNo ? '號 ' : '') + // Street Name
        villageName + villageNo + (villageName && villageNo ? '號 ' : '') + // Village Name
        estate + ' ' + // Estate
        building + ' ' + // Building
        (blockNo ? '第' : '') + blockNo + blockDes; // Block
    }
  },
  mounted() {
    this.$i18n.add("en", langEn);
    this.$i18n.add("zh", langZh);
  },
}
</script>

<style scoped>
.search-content {
  width: 30vw;
}
.search-input-wrapper {
  width: 100%;
  display: flex;
}
.search-input {
  flex: 1;
  border-radius: 4px 0px 0px 4px;
}
.search-button {
  border-radius: 0px 4px 4px 0px;
}
.clear-button {
  border-radius: 0px 0px 0px 0px;
}
.result-list-group {
  max-height: calc(90vh - 2rem - 31px);
  overflow: auto;
}
.result-list {
  width: 30vw;
}
.list-group-item {
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 4px;
  padding-bottom: 4px;
  font-size: 14px;
}
.list-group-item-expand {
  padding: 0px;
}
@media screen and (max-width: 991px) {
  .search-content {
    width: calc(100% - 4rem);
  }
  .result-list-group {
    max-height: calc(50vh - 2rem - 31px);
  }
  .result-list {
    width: calc(100% - 4rem);
  }
}
</style>
